// extracted by mini-css-extract-plugin
export default {"divider":"courseList_divider__DvXCt","eachCollapse":"courseList_eachCollapse__GygN4","deleteBtn":"courseList_deleteBtn__Xye4u","deleteBlock":"courseList_deleteBlock__BvAbt"};